import { render, staticRenderFns } from "./ViewArchiveActionPlans.vue?vue&type=template&id=046003a9&scoped=true&"
import script from "./ViewArchiveActionPlans.vue?vue&type=script&lang=js&"
export * from "./ViewArchiveActionPlans.vue?vue&type=script&lang=js&"
import style0 from "./ViewArchiveActionPlans.vue?vue&type=style&index=0&id=046003a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046003a9",
  null
  
)

export default component.exports